export class AuthorizationError extends Error {}
